<!--左侧菜单组件-->
<template>
  <v-navigation-drawer app dark floating persistent class="Nav" width="130">
    <div class="nav-content">
      <div v-for="(item, key) in base.menus" :key="item.title">
        <div class="children">
          <v-list-item
            :key="key"
            :to="item.to"
            :target="item.target"
            class="listitem"
          >
            <div :class="path == item.to ? 'active' : 'v-item-content'">
              <v-icon @click="path = item.to" class="v-item-icon">{{
                item.icon
              }}</v-icon>
              {{ item.title }}
            </div>
          </v-list-item>
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>
<script>
import { mapState } from 'vuex'
export default {
  components: {},
  name: 'app',
  data() {
    return {
      title: null,
      path: '',
    }
  },
  mounted: function () {
    this.path = this.$route.path
  },
  computed: {
    ...mapState({
      base: (state) => state.base,
    }),
  },
  methods: {},
}
</script>
<style>
.Nav {
  margin-top: -12px;
  width: 260px;
  background: black;
  font-size: 18px;
  min-height: 696px;
  height: 100%;
  box-shadow: none;
}
.nav-content {
  width: 130px;
  background: transparent;
  font-size: 18px;
  min-height: 696px;
  height: 100%;
  box-shadow: none;
  overflow: hidden;
  padding-top: 105px;
  text-align: center;
}
.children {
  text-align: left;
  font-size: 16px;
  font-weight: 100;
  color: #565555;
}
.v-item-icon {
  height: 40px;
  width: 90px;
  font-size: 32px !important;
  color: white;
}
.v-item-content {
  text-align: center;
  color: white;
  font-size: 14px;
}
.active .v-item-icon {
  height: 40px;
  width: 90px;
  font-size: 32px;
  color: #1cade4;
}
.active {
  text-align: center;
  font-size: 14px;
  color: #1cade4;
}
.listitem {
  height: 80px;
}
:deep .v-list-item--link:before{
  background-color: rgb(69 125 182) !important;
}
</style>
